export default __webpack_public_path__ + "static/media/visaafter.16b7d32e.svg";